<div class="orders">
    <div class="container head">
        <div class="row block">
            <div class="col-md-12">
                <h3 class="heading">Mes commandes:</h3>
                <hr class="half_space">
                <div *ngIf="orders?.length==0" class="text-center">
                    <p>Aucune commande pour le moment</p>
                </div>
                <table *ngIf="orders?.length>0" class="table-striped" width="100%">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th class="text-center">Montant</th>
                            <th class="text-center">Type</th>
                            <th>Modes de réglement</th>
                            <th>Statut</th>
                            <th>Ticket</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let order of orders;let i=index">
                            <td>{{order.createdAt | date: 'dd/MM/yyyy HH:mm'}}</td>
                            <td class="text-center" *ngIf="order?.discount==0">
                                {{order?.amount | number : '1.2-2'}} €
                            </td>
                            <td class="text-center" *ngIf="order?.discount>0">
                                <s class="text-danger">{{order?.amount | number : '1.2-2'}} €</s>
                                <br> {{order?.total | number : '1.2-2'}} €
                            </td>
                            <td class="text-center">{{order.type}}</td>
                            <td>
                                <span *ngFor="let mode of order.PaymentModes">{{mode.paymentMode.label}}, </span>
                            </td>
                            <td class="center">
                                <span class="label"
                                    [ngClass]="{'label-danger':order.idStatus==8 || order.idStatus==9,'label-primary':order.idStatus==2,'label-success':order.idStatus==5 || order.idStatus==4,'label-default':order.idStatus==3 || order.idStatus==6,'label-warning':order.idStatus==1}">{{order.status}}</span>
                            </td>
                            <td>
                                <button (click)="seeTicket(i)" title="Afficher le ticket" placement="bottom"
                                    class="button">
                                    <i class="flaticon-receipt cursor-pointer"></i>
                                </button>
                            </td>
                            <td>
                                <button *ngIf="order.idStatus==9 && !order.paid" (click)="payer(i)" title="payer la commande"
                                    placement="bottom" class="btn btn-success">
                                    Payer la commande
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<!-- <ng-template #template>
    <div class="modal-body">
        <app-ticket id="ticket2" [idOrder]="idOrder2"></app-ticket>
    </div>
</ng-template> -->